export interface AuraSuggestedQuestion {
    id: number;
    questionText: string;
    displayOrder: number;
    isActive: boolean;
}

export interface AuraLinkedVertical {
    id: number;
    verticalName: string;
    isActive: boolean;
    activatedAt: string | null;
}

export interface AuraContext {
    enabled: boolean;
    linkedVertical: AuraLinkedVertical | null;
    suggestedQuestions: AuraSuggestedQuestion[];
}
